import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {mapToRequestDemo} from './RequestDemo.utils'
import {requestDemoApi} from 'services/registration.service'

export interface RequestDemo {
    isLoading: boolean
    error: any
    response: object
    payload: object
}

const initialState: RequestDemo = {
    isLoading: false,
    error: null,
    response: {},
    payload: {}
}

const throwError = (data) => {
    if (!data.successFlag || typeof data === 'string') {
        throw Error(`${data?.errorList[0]?.text}`)
    }
}

export const requestDemo = createAsyncThunk('requestDemo', async (payload: any, {rejectWithValue}) => {
    try {
        const requestDemoRequest = mapToRequestDemo(payload)
        const {data} = await requestDemoApi(requestDemoRequest)
        throwError(data)
        return data
    } catch (err: any) {
        if (err.code === 'ERR_BAD_RESPONSE') {
            return rejectWithValue('500 - Something Went Wrong, Internal Server Error')
        }
        return rejectWithValue(err.message)
    }
})

const requestDemoSlice = createSlice({
    name: 'request-demo',
    initialState,
    reducers: {},
    extraReducers: function (builder) {
        builder.addCase(requestDemo.pending, (state: any, action) => {
            state.isLoading = true
            state.error = null
        })
        builder.addCase(requestDemo.fulfilled, (state, action) => {
            const data: any = action.payload
            state.isLoading = false
            state.response = data
            state.payload = data
            state.error = null
        })
        builder.addCase(requestDemo.rejected, (state, action: any) => {
            state.isLoading = false
            state.response = {}
            state.payload = {}
            state.error = action.payload
        })
    }
})

export const {reducer: requestDemoReducer} = requestDemoSlice
